<template>
  <div class="h-screen bg-gray-100">
    <slot />
  </div>
</template>

<script setup lang="ts">
// 简化的默认布局
</script>